import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Menu, Icon, Typography, Badge } from 'antd'
import { useMount } from 'react-use'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import * as userSelector from '@/models/user/selectors'
import * as notifiesSelector from '@/models/notifies/selectors'
import styles from './styles.module.scss'
import getNavs from '@/navs'
import MenuFont from '@/components/MenuFont';
import * as tenantAction from '@/models/tenants/actions'
import * as couponsAction from '@/models/coupons/actions'
import * as notifiesAction from '@/models/notifies/actions'

const { SubMenu } = Menu;
const checkActive = nav => {
  const reg = new RegExp(`^${nav.to}`)
  return (_, location) => reg.test(location.pathname)
}


export default function Sidebar(props) {
  const { isCollapsed } = props
  const dispatch = useDispatch()
  const [navs, setNavs] = useState([])
  const user = useSelector(userSelector.getCurrentUser)
  const noDoFeedbackNum = useSelector(notifiesSelector.noDoFeedbackNum)
  const replyRefreshKey = useSelector(notifiesSelector.replyRefreshKey)
  const tenant = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant'])
  //const tenantId = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant', '_id'])

  const showTenantDialog = useCallback(() => {
    dispatch(tenantAction.showInfoDialog({
      id: tenant?._id
    }))
  })
  const showCouponsDialog = useCallback(() => {
    dispatch(couponsAction.showInfoDialog({
    }))
  })

  useMount(() => {

  })

  useEffect(() => {
    const navs = getNavs(user.toJS())
    setNavs(navs)
  }, [user])

  useEffect(() => {
    if (!tenant) {
      dispatch(notifiesAction.fetchNoDoFeedback())
    }
  }, [replyRefreshKey])

  return (
    <div className={styles.sidebar}>
      <a href="/" className={styles.logo}>
        {isCollapsed ?
          <img src="/images/sider-logo2.png" style={{ width: isCollapsed ? 48 : '' }} /> :
          <img src="/images/sider-logo.png" />}
        {/* <h1>小兵速帮</h1> */}
        {/* <div className={cn(styles.app_mode, styles[process.env.APP_MODE])}>
          {
            process.env.APP_MODE === 'tenant' ? '租户端' : '管理端'
          }
        </div> */}
      </a>
      {tenant && user.getIn(['staff', 'tenant', 'tenant_no']) && <Typography.Paragraph
        style={{ textAlign: 'left', color: '#fff', marginBottom: 0,marginLeft:35 }}
      > 企业名称：{user.getIn(['staff', 'tenant', 'short_name'])}
      </Typography.Paragraph>}
      {tenant && user.getIn(['staff', 'tenant', 'tenant_no']) && <Typography.Paragraph
        copyable={{ text: user.getIn(['staff', 'tenant', 'tenant_no']) }}
        style={{ textAlign: 'left', color: '#fff', marginBottom: 0,marginLeft:35 }}
      >企业码：{user.getIn(['staff', 'tenant', 'tenant_no'])}
      </Typography.Paragraph>}

      <div className={styles.menuwrap}>
        <Menu mode="inline">
          {
            navs.map(nav => {
              if (nav.children && nav.children.length > 0) {
                return <SubMenu key={nav.name} title={<span>
                  <span className="menu-item-icon">
                    {nav.icon && <MenuFont type={nav.icon} />}
                  </span>
                  <span className="menu-item-text">
                    {nav.name}
                  </span>
                </span>}>
                  {nav.children.map(child => (
                    <Menu.Item key={child.name}>
                      <NavLink
                        key={child.to}
                        to={child.to}
                        exact={child.exact}
                        strict={child.strict}
                        activeClassName={styles.active}
                        className="menu-item"
                        isActive={child.isActive || checkActive(child)}>
                        <span className="menu-item-icon">
                          {child.icon && <MenuFont type={child.icon} />}
                        </span>
                        <span className="menu-item-text">
                          {child.name}
                        </span>
                      </NavLink>
                    </Menu.Item>
                  ))
                  }
                </SubMenu>
              } else {
                return <Menu.Item key={nav.name}>
                  <NavLink
                    key={nav.to}
                    to={nav.to}
                    exact={nav.exact}
                    strict={nav.strict}
                    activeClassName={styles.active}
                    className="menu-item"
                    isActive={nav.isActive || checkActive(nav)}>
                    <span className="menu-item-icon">
                      {nav.icon && <MenuFont type={nav.icon} />}
                    </span>
                    <span className="menu-item-text">
                      {nav.name}
                    </span>
                    {!tenant && nav.to === '/notifies' && <Badge count={noDoFeedbackNum}
                      style={{ marginRight: 5, transform: 'scale(0.8)', boxShadow: 'none' }}
                    />}
                  </NavLink>
                </Menu.Item>
              }
            })
          }
          {process.env.APP_MODE == 'tenant' && user.get('isTouer') &&
            <Menu.Item key="enterprises" onClick={showTenantDialog}>
              <div className="menu-item">
                <span className="menu-item-icon">
                  <MenuFont type="icon-enterprises" />
                </span>
                <span className="menu-item-text">
                  企业信息
                </span>
              </div>
            </Menu.Item>
          }
          {process.env.APP_MODE == 'tenant' &&
            <Menu.Item key="coupon" onClick={showCouponsDialog}>
              <div className="menu-item">
                <span className="menu-item-icon">
                  <MenuFont type="icon-coupon" />
                </span>
                <span className="menu-item-text">
                  代金券
                </span>
              </div>
            </Menu.Item>
          }
        </Menu>
      </div>
    </div>
  )
}